import Vue from 'vue'
import CKEditor from '@ckeditor/ckeditor5-vue2'

import ClassicEditor from 'ckeditor5-custom-build/build/ckeditor'

Vue.use(CKEditor)

export default {
  ClassicEditor,
  editorConfig: {
    fontSize: {
      options: [9, 12, 14, 'default', 16, 18, 22, 24, 28, 32]
    },
    toolbar: {
      items: [
        'bold', 'italic', 'underline', 'link', 'bulletedList', 'numberedList', '|',
        'alignment', 'fontSize', 'fontColor', 'fontBackgroundColor', 'fontFamily', '|',
        'indent', 'outdent', '|',
        'imageUpload', 'blockQuote', 'insertTable', 'mediaEmbed', 'undo', 'redo'
      ]
    },
    image: {
      styles: ['full', 'alignLeft', 'alignCenter', 'alignRight'],
      toolbar: ['imageStyle:full', 'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight', '|', 'imageTextAlternative']
    },
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableCellProperties', 'tableProperties']
    },
    alignment: {
      options: ['left', 'center', 'right']
    },
    // 刪除工具列的功能
    placeholder: '',
    // 當編輯器內容為空時顯示此字串
    initialData: '',
    // 初始化載入文字
    heading: {
    // 設定 Heading 內的樣式，可新增多個
      options: [
        {
          model: 'paragraph',
          title: '文字段落',
          class: 'ck-heading_paragraph'
        },
        {
          model: 'heading1',
          view: 'h2',
          title: '標題1',
          class: 'ck-heading_heading1'
        },
        {
          model: 'heading2',
          view: 'h3',
          title: '標題2',
          class: 'ck-heading_heading2'
        },
        {
          model: 'heading3',
          view: 'h4',
          title: '標題3',
          class: 'ck-heading_heading3'
        }
      ]
    },
    language: 'zh'
    // 設定語言
  }
}
